import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const TABS = ['Artists', 'Show History', 'Co-Members', 'Shows Map'];


const styles = {
    container: { maxWidth: '1100px', margin: '0 auto', padding: '32px 24px', color: '#e0e0e0' },
    profileRow: { display: 'flex', gap: '28px', alignItems: 'flex-start', marginBottom: '32px' },
    avatar: { width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 },
    avatarPlaceholder: {
        width: '100px', height: '100px', borderRadius: '50%', backgroundColor: '#2a2a2a',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#bb86fc', fontWeight: 700, fontSize: '36px', flexShrink: 0
    },
    profileInfo: { flex: 1 },
    name: { fontSize: '30px', fontWeight: 700, color: '#ffffff', margin: '0 0 6px 0' },
    location: { fontSize: '16px', color: '#aaa', marginBottom: '8px' },
    fka: { fontSize: '14px', color: '#888', fontStyle: 'italic', marginBottom: '6px' },
    bio: { fontSize: '15px', color: '#ccc', lineHeight: '1.7', marginTop: '16px', padding: '16px', backgroundColor: '#1e1e1e', borderRadius: '8px', border: '1px solid #2a2a2a' },
    linksRow: { display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '16px', marginBottom: '8px' },
    linkChip: { backgroundColor: '#1e1e1e', border: '1px solid #444', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', color: '#bb86fc', textDecoration: 'none', fontWeight: 'bold' },
    editBtn: { backgroundColor: 'transparent', border: '1px solid #555', borderRadius: '6px', color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: '13px', textDecoration: 'none', marginTop: '12px', display: 'inline-block' },
    tabBar: { display: 'flex', gap: '4px', borderBottom: '2px solid #333', marginBottom: '24px', flexWrap: 'wrap' },
    tab: { padding: '10px 18px', cursor: 'pointer', border: 'none', background: 'none', color: '#aaa', fontSize: '14px', fontWeight: 500, borderBottom: '2px solid transparent', marginBottom: '-2px' },
    tabActive: { color: '#bb86fc', borderBottomColor: '#bb86fc' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { textAlign: 'left', padding: '10px 14px', borderBottom: '2px solid #333', color: '#aaa', fontSize: '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' },
    td: { padding: '12px 14px', borderBottom: '1px solid #2a2a2a', fontSize: '12px', verticalAlign: 'middle' },
    link: { color: '#bb86fc', textDecoration: 'none' },
    emptyTab: { color: '#666', padding: '40px 0', textAlign: 'center' },
    badge: { display: 'inline-block', backgroundColor: '#2a2a2a', color: '#aaa', borderRadius: '12px', padding: '2px 10px', fontSize: '13px' },
    rolePill: { display: 'inline-block', backgroundColor: '#1e1240', color: '#bb86fc', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', border: '1px solid #3d2a7a', marginRight: '4px' },
    coMemberRow: { display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0', borderBottom: '1px solid #2a2a2a' },
    coAvatar: { width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' },
    coAvatarPlaceholder: { width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#2a2a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bb86fc', fontWeight: 700, fontSize: '16px', flexShrink: 0 },
    mapContainer: { height: '480px', borderRadius: '8px', overflow: 'hidden' },
    searchInput: { width: '100%', padding: '10px 14px', backgroundColor: '#2a2a2a', border: '1px solid #444', borderRadius: '6px', color: '#e0e0e0', fontSize: '14px', marginBottom: '16px', boxSizing: 'border-box' },
    tabSearch: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '6px', padding: '10px 14px', fontSize: '14px', color: '#e0e0e0', width: '100%', marginBottom: '16px', boxSizing: 'border-box' },
    tableContainer: { overflowX: 'auto' },
    tableLink: { color: '#bb86fc', textDecoration: 'none' },
    trEven: { backgroundColor: '#1e1e1e' },
    trOdd: { backgroundColor: '#1a1a1a' },
    pagination: { display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '20px', flexWrap: 'wrap' },
    pageBtn: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '4px', padding: '6px 12px', fontSize: '13px', color: '#aaa', cursor: 'pointer' },
    pageBtnActive: { backgroundColor: '#bb86fc', borderColor: '#bb86fc', color: '#121212', fontWeight: 'bold' },
    pageBtnDisabled: { opacity: 0.35, cursor: 'default' },
};

const PAGE_SIZE = 25;

function Pagination({ currentPage, totalItems, onPageChange }) {
    const totalPages = Math.ceil(totalItems / PAGE_SIZE);
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return (
        <div style={styles.pagination}>
            <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} style={{ ...styles.pageBtn, ...(currentPage === 1 ? styles.pageBtnDisabled : {}) }}>‹ Prev</button>
            {pages.map(p => (
                <button key={p} onClick={() => onPageChange(p)} style={{ ...styles.pageBtn, ...(p === currentPage ? styles.pageBtnActive : {}) }}>{p}</button>
            ))}
            <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ ...styles.pageBtn, ...(currentPage === totalPages ? styles.pageBtnDisabled : {}) }}>Next ›</button>
        </div>
    );
}

function ShowHistoryTab({ shows }) {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    if (!shows || shows.length === 0) return <div style={styles.emptyTab}>No shows recorded yet.</div>;

    const q = search.toLowerCase();
    const filtered = search ? shows.filter(s => {
        const dateStr = s.event_date
            ? new Date(s.event_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
            : '';
        return [dateStr, s.city, s.state, s.country, s.venue_name, s.other_artists, s.festival_name, s.member_of_names]
            .some(val => val && val.toLowerCase().includes(q));
    }) : shows;

    const totalShows = shows.length;
    const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    const handleSearch = (e) => { setSearch(e.target.value); setPage(1); };

    return (
        <div>
            <input
                type="text"
                placeholder="Search by date, city, state, country, venue, artist..."
                value={search}
                onChange={handleSearch}
                style={styles.tabSearch}
            />
            {filtered.length === 0 ? (
                <div style={styles.emptyTab}>No shows match your search.</div>
            ) : (
                <>
                    <div style={styles.tableContainer}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>Show #</th>
                                    <th style={styles.th}>Date</th>
                                    <th style={styles.th}>Member of</th>
                                    <th style={styles.th}>City</th>
                                    <th style={styles.th}>State</th>
                                    <th style={styles.th}>Country</th>
                                    <th style={styles.th}>Venue</th>
                                    <th style={styles.th}>Artists</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginated.map((s, idx) => {
                                    const globalIdx = shows.indexOf(s);
                                    const showNum = totalShows - globalIdx;
                                    const formattedDate = s.event_date
                                        ? new Date(s.event_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                                        : '—';
                                    return (
                                        <tr key={s.event_id} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                            <td style={{ ...styles.td, fontWeight: 'bold' }}>
                                                <Link to={`/events/${s.event_slug}`} style={styles.tableLink}>{showNum}</Link>
                                            </td>
                                            <td style={{ ...styles.td, whiteSpace: 'nowrap' }}>{formattedDate}</td>
                                            <td style={styles.td}>
                                                {s.member_of_names
                                                    ? s.member_of_names.split(', ').map((name, i) => {
                                                        const slugs = s.member_of_slugs ? s.member_of_slugs.split('|') : [];
                                                        const slug = slugs[i];
                                                        return slug
                                                            ? <React.Fragment key={i}>{i > 0 && ', '}<Link to={`/artists/${slug}`} style={styles.tableLink}>{name}</Link></React.Fragment>
                                                            : <React.Fragment key={i}>{i > 0 && ', '}{name}</React.Fragment>;
                                                    })
                                                    : '—'}
                                            </td>
                                            <td style={styles.td}>{s.city || '—'}</td>
                                            <td style={styles.td}>{s.state || '—'}</td>
                                            <td style={styles.td}>{s.country || '—'}</td>
                                            <td style={styles.td}>
                                                {s.venue_slug
                                                    ? <Link to={`/venues/${s.venue_slug}`} style={styles.tableLink}>{s.venue_name}</Link>
                                                    : s.venue_name || '—'}
                                            </td>
                                            <td style={{ ...styles.td, color: '#aaa' }}>
                                                {s.festival_name && s.festival_slug
                                                    ? <><Link to={`/festivals/${s.festival_slug}`} style={{ color: '#bb86fc', textDecoration: 'none', fontWeight: 'bold' }}>{s.festival_name}</Link>{s.other_artists ? ` - ${s.other_artists}` : ''}</>
                                                    : s.other_artists || '—'
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <Pagination currentPage={page} totalItems={filtered.length} onPageChange={setPage} />
                </>
            )}
        </div>
    );
}

function ArtistsTab({ artists }) {
    if (!artists || artists.length === 0) return <div style={styles.emptyTab}>No artist associations found.</div>;
    return (
        <table style={styles.table}>
            <thead>
                <tr>
                    <th style={styles.th}>Artist</th>
                    <th style={styles.th}>Role(s)</th>
                    <th style={styles.th}>Shows</th>
                    <th style={styles.th}>First Show</th>
                    <th style={styles.th}>Last Show</th>
                </tr>
            </thead>
            <tbody>
                {artists.map(a => (
                    <tr key={a.id}>
                        <td style={styles.td}><Link to={`/artists/${a.slug}`} style={styles.link}>{a.name}</Link></td>
                        <td style={styles.td}>
                            {a.roles ? a.roles.split(', ').map((r, i) => <span key={i} style={styles.rolePill}>{r}</span>) : <span style={{ color: '#555' }}>—</span>}
                        </td>
                        <td style={styles.td}><span style={styles.badge}>{a.show_count}</span></td>
                        <td style={styles.td}>{a.first_show ? new Date(a.first_show).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }) : '—'}</td>
                        <td style={styles.td}>{a.last_show ? new Date(a.last_show).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }) : '—'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

function CoMembersTab({ coMembers }) {
    if (!coMembers || coMembers.length === 0) return <div style={styles.emptyTab}>No co-members found yet.</div>;
    return (
        <div>
            {coMembers.map(m => (
                <div key={m.id} style={styles.coMemberRow}>
                    {m.image_url
                        ? <img src={m.image_url} alt={m.name} style={styles.coAvatar} />
                        : <div style={styles.coAvatarPlaceholder}>{m.name.charAt(0).toUpperCase()}</div>
                    }
                    <div style={{ flex: 1 }}>
                        <Link to={`/members/${m.slug}`} style={{ ...styles.link, fontWeight: 600 }}>{m.name}</Link>
                        <div style={{ marginTop: '3px' }}>
                            {m.roles && m.roles.split(', ').map((r, i) => <span key={i} style={styles.rolePill}>{r}</span>)}
                        </div>
                    </div>
                    <span style={styles.badge}>{m.shows_together} show{m.shows_together !== 1 ? 's' : ''} together</span>
                </div>
            ))}
        </div>
    );
}

function ShowsMapTab({ showMap }) {
    const mapRef = React.useRef(null);
    const mapInstanceRef = React.useRef(null);
    const [leafletReady, setLeafletReady] = React.useState(!!window.L);

    React.useEffect(() => {
        if (window.L) { setLeafletReady(true); return; }
        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css';
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(link);
        }
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.onload = () => setLeafletReady(true);
        document.head.appendChild(script);
    }, []);

    React.useEffect(() => {
        if (!leafletReady || !mapRef.current || !showMap || showMap.length === 0) return;
        if (mapInstanceRef.current) {
            mapInstanceRef.current.remove();
            mapInstanceRef.current = null;
        }
        const L = window.L;
        const map = L.map(mapRef.current, { zoomControl: true });
        mapInstanceRef.current = map;

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors',
            maxZoom: 18,
        }).addTo(map);

        const markerIcon = L.divIcon({
            className: '',
            html: `<div style="width:12px;height:12px;background:#bb86fc;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.5);"></div>`,
            iconSize: [12, 12], iconAnchor: [6, 6], popupAnchor: [0, -8],
        });

        const bounds = [];
        showMap.forEach(venue => {
            const lat = parseFloat(venue.lat);
            const lng = parseFloat(venue.lng);
            if (isNaN(lat) || isNaN(lng)) return;
            bounds.push([lat, lng]);
            const dates = venue.show_dates
                ? venue.show_dates.split(',').map(d => {
                    const dt = new Date(d.trim());
                    return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
                }) : [];
            const locationStr = [venue.city, venue.state, venue.country].filter(Boolean).join(', ');
            const showCount = parseInt(venue.show_count);
            const popupHtml = `
                <div style="font-family:sans-serif;min-width:180px;max-width:260px;">
                    <div style="font-weight:bold;font-size:14px;margin-bottom:4px;">
                        <a href="/venues/${venue.venue_slug}" style="color:#bb86fc;text-decoration:none;">${venue.venue_name} ↗</a>
                    </div>
                    ${locationStr ? `<div style="font-size:12px;color:#888;margin-bottom:6px;">${locationStr}</div>` : ''}
                    <div style="font-size:12px;color:#aaa;">
                        <strong style="color:#e0e0e0;">${showCount}</strong> show${showCount !== 1 ? 's' : ''}
                    </div>
                    ${dates.length > 0 ? `<div style="font-size:11px;color:#999;line-height:1.6;margin-top:6px;">${dates.slice(0, 10).join('<br/>')}${dates.length > 10 ? `<br/><em>+${dates.length - 10} more</em>` : ''}</div>` : ''}
                </div>`;
            L.marker([lat, lng], { icon: markerIcon })
                .bindPopup(popupHtml, { maxWidth: 280 })
                .addTo(map);
        });

        if (bounds.length === 1) { map.setView(bounds[0], 12); }
        else if (bounds.length > 1) { map.fitBounds(bounds, { padding: [40, 40] }); }

        return () => {
            if (mapInstanceRef.current) { mapInstanceRef.current.remove(); mapInstanceRef.current = null; }
        };
    }, [leafletReady, showMap]);

    if (!showMap || showMap.length === 0) return <div style={styles.emptyTab}>No geocoded venues found.</div>;

    return (
        <div>
            <div style={{ marginBottom: '12px', fontSize: '13px', color: '#888' }}>
                {showMap.length} venue{showMap.length !== 1 ? 's' : ''} with location data · Click a pin for details
            </div>
            {!leafletReady
                ? <div style={styles.emptyTab}>Loading map...</div>
                : <div ref={mapRef} style={{ height: '480px', borderRadius: '8px', border: '1px solid #333', overflow: 'hidden' }} />
            }
        </div>
    );
}

export default function MemberDetail() {
    const { slug } = useParams();
    const [data, setData] = useState(null);
    const [activeTab, setActiveTab] = useState('Artists');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get(`${config.API_URL}/members/${slug}`)
            .then(res => setData(res.data))
            .catch(() => setError('Member not found.'))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div style={{ color: '#e0e0e0', padding: '40px', textAlign: 'center' }}>Loading...</div>;
    if (error || !data) return <div style={{ color: '#cf6679', padding: '40px', textAlign: 'center' }}>{error || 'Member not found.'}</div>;

    const { member, links, artists, show_history, co_members, show_map } = data;

    return (
        <div style={styles.container}>
            <div style={styles.profileRow}>
                {member.image_url
                    ? <img src={member.image_url} alt={member.name} style={styles.avatar} />
                    : <div style={styles.avatarPlaceholder}>{member.name.charAt(0).toUpperCase()}</div>
                }
                <div style={styles.profileInfo}>
                    <h1 style={styles.name}>{member.name}</h1>

                    {[member.city, member.state_code, member.country_code].filter(Boolean).length > 0 && (
                        <div style={styles.location}>
                            {[member.city, member.state_code, member.country_code].filter(Boolean).join(', ')}
                        </div>
                    )}

                    {(member.hometown_city || member.hometown_state || member.hometown_country) && (
                        <div style={styles.fka}>
                            Hometown: {[member.hometown_city, member.hometown_state, member.hometown_country].filter(Boolean).join(', ')}
                        </div>
                    )}

                    {member.bio && <div style={styles.bio}>{member.bio}</div>}

                    {links && links.length > 0 && (
                        <div style={styles.linksRow}>
                            {links.map((l, i) => (
                                <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" style={styles.linkChip}>{l.description} ↗</a>
                            ))}
                        </div>
                    )}

                    <Link to={`/members/${slug}/edit`} style={styles.editBtn}>Edit Member</Link>
                </div>
            </div>

            <div style={styles.tabBar}>
                {TABS.map(tab => (
                    <button
                        key={tab}
                        style={{ ...styles.tab, ...(activeTab === tab ? styles.tabActive : {}) }}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                        {tab === 'Artists' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{artists.length}</span>}
                        {tab === 'Show History' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{show_history.length}</span>}
                        {tab === 'Co-Members' && <span style={{ ...styles.badge, marginLeft: '6px' }}>{co_members.length}</span>}
                    </button>
                ))}
            </div>

            {activeTab === 'Artists' && <ArtistsTab artists={artists} />}
            {activeTab === 'Show History' && <ShowHistoryTab shows={show_history} />}
            {activeTab === 'Co-Members' && <CoMembersTab coMembers={co_members} />}
            {activeTab === 'Shows Map' && <ShowsMapTab showMap={show_map} />}
        </div>
    );
}
